import { AreaChart } from '@tremor/react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { MotionCard } from '@/components/motion/MotionCard';

export interface TrendPoint {
  date: string;
  current: number;
  previous?: number;
}

interface Props {
  title: string;
  data: TrendPoint[];
  formatValue?: (n: number) => string;
  loading?: boolean;
}

export function TrendChart({ title, data, formatValue, loading }: Props) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-64 w-full" />
        </CardContent>
      </Card>
    );
  }

  return (
    <MotionCard>
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <AreaChart
            data={data}
            index="date"
            categories={['current', 'previous'].filter((c) =>
              data.some((d) => (d as unknown as Record<string, unknown>)[c] !== undefined),
            )}
            colors={['emerald', 'gray']}
            valueFormatter={formatValue}
            showGridLines={false}
            showLegend={false}
            showAnimation
            curveType="monotone"
            className="h-64"
          />
        </CardContent>
      </Card>
    </MotionCard>
  );
}
